import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: "smallNumber",
})
export class SmallNumberPipe implements PipeTransform {

    transform(input: number): boolean {
        return Math.abs(input) < 0.01
    }

}